import React, { useEffect, useRef } from "react";

import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

interface Props {
  primaryColor?: string;
  calories: string;
  size?: "small";
  label?: string;
  data: Array<{
    value: number;
    color: string;
  }>;
}

const useStyles = makeStyles()({
  root: {
    position: "relative",
    overflow: "hidden",
    width: 110,
    height: 110,
  },
  rootSmall: {
    width: 90,
    height: 90,
  },
  container: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50% , -50%)",
  },
  progress: {
    textAlign: "center",
    fontSize: 28,
    fontWeight: 700,
  },
  progressSmall: {
    fontSize: 20,
  },
  caloriesLabeL: {
    textAlign: "center",
    fontSize: 14,
    fontWeight: 600,
    color: colors.gray,
  },
  caloriesLabelSmall: {
    fontSize: 13,
    color: "#595F68",
  },
});

const CircularProgressBar: React.FC<Props> = ({
  size,
  label = "Calories",
  primaryColor = colors.light,
  calories,
  data,
}) => {
  const { classes, cx } = useStyles();
  const mainCanvas = useRef<HTMLCanvasElement>(null);
  const isSmall = size == "small";
  function renderPathArcStroke(
    ctx: CanvasRenderingContext2D | null,
    color: string,
    startAngle: number,
    endAngle: number
  ) {
    ctx?.beginPath();
    if (isSmall) {
      ctx?.arc(45, 45, 40, startAngle, endAngle);
    } else {
      ctx?.arc(55, 55, 50, startAngle, endAngle);
    }

    if (ctx?.strokeStyle) {
      ctx!.strokeStyle = color;
      ctx!.lineWidth = 6;
    }
    ctx?.stroke();
  }

  useEffect(() => {
    const c = mainCanvas.current;
    const ctx = c?.getContext("2d");
    renderPathArcStroke(ctx!, primaryColor, 0 * Math.PI, 2 * Math.PI);

    let next_start = 0;
    for (let i = 0; i < data.length; i++) {
      const divided = data[i].value / 50;
      const start = startAtGap(i > 0 ? next_start : 0) * Math.PI;
      const end = startAtGap(divided + next_start) * Math.PI;
      renderPathArcStroke(ctx!, data[i].color, start, end);
      next_start += divided;
    }

    function startAtGap(value: number) {
      return value - 0.5;
    }
  }, [data]);
  return (
    <div className={cx(classes.root, { [classes.rootSmall]: isSmall })}>
      <div className={classes.container}>
        <div>
          <Typography
            className={cx(classes.progress, {
              [classes.progressSmall]: isSmall,
            })}
            variant="body1"
          >
            {calories}
          </Typography>
          <Typography
            className={cx(classes.caloriesLabeL, {
              [classes.caloriesLabelSmall]: isSmall,
            })}
            variant="body1"
          >
            {label}
          </Typography>
        </div>
      </div>
      <canvas ref={mainCanvas}></canvas>
    </div>
  );
};

export default CircularProgressBar;
